/**
 * Host PartyKit (Worker) e constantes de timing compartilhadas.
 * SRP: resolução/validação de host — sem sockets nem circuit.
 */

/** Worker Cloudflare atual (PartyServer). O host clássico *.partykit.dev morreu (DNS). */
export const CANONICAL_PARTYKIT_HOST = 'adlitics-chat.contato-3b6.workers.dev';

export const PARTYKIT_CONNECTION_DEBOUNCE_MS = 500;
export const PARTYKIT_CHAT_DEBOUNCE_MS = 350;
export const PARTYKIT_MESSAGE_REFRESH_MS = 250;
/** Throttle de fetch de mensagens e debounce de refresh da lista (mesmo ritmo). */
export const PARTYKIT_FETCH_THROTTLE_MS = 400;
export const PARTYKIT_LIST_REFRESH_MS = PARTYKIT_FETCH_THROTTLE_MS;

function isBlankHost(host: string | undefined): boolean {
    const trimmed = host?.trim();
    return !trimmed || trimmed === 'undefined' || trimmed === 'null';
}

/**
 * Resolve o host do realtime. Env legada `*.partykit.dev` não resolve mais
 * (ERR_NAME_NOT_RESOLVED / WSS failed) — força o Worker canônico.
 */
export function resolvePartykitHost(
    rawHost: string | undefined = import.meta.env.VITE_PARTYKIT_HOST,
): string {
    if (isBlankHost(rawHost)) return CANONICAL_PARTYKIT_HOST;
    const host = rawHost!.trim();
    if (/\.partykit\.dev$/i.test(host)) return CANONICAL_PARTYKIT_HOST;
    return host;
}

/** Host efetivo do processo (env resolvida uma vez). */
export const PARTYKIT_HOST = resolvePartykitHost();

export function isValidPartykitHost(): boolean {
    if (isBlankHost(PARTYKIT_HOST)) return false;
    if (
        PARTYKIT_HOST.includes('localhost')
        && typeof window !== 'undefined'
        && !window.location.hostname.includes('localhost')
    ) {
        return false;
    }
    return true;
}
